// TSS vite/02 — centralized constants.

export const MAX_NAME_LEN = 255;
export const MAX_EMAIL_LEN = 255;
export const MAX_PHONE_LEN = 32;
export const MAX_COMPANY_LEN = 120;
export const MAX_MESSAGE_LEN = 1500;
